import React from 'react';
import PropTypes from 'prop-types';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import { Box, Button, Dialog, DialogContent, Typography } from '@mui/material';

import CheckBox from '../../../../../../components/CheckBox/CheckBox';
import theme from '../../../../../../theme';
import { BLACK } from '../../../../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../../../../theme/fontConstants';

const styles = theme?.components?.userCard;

const UserAccountActivationToggleConfirmationModal = ({
  content,
  isDialogOpen,
  isChecked,
  onClose,
  onConfirm,
  onCheckChange,
}) => (
  <Dialog
    open={isDialogOpen}
    onClose={onClose}
    maxWidth="sm"
    fullWidth
    sx={{
      '& .MuiPaper-root': {
        borderRadius: '16px',
        padding: '30px 38px 30px 38px',
      },
    }}
  >
    <DialogContent>
      <Box display="flex" sx={{ flexDirection: 'column', gap: '16px' }}>
        <Typography sx={styles.headerStyle}>
          {LanguageConverterV2(content.confirmation.headerKey)}
        </Typography>
        <Typography>{LanguageConverterV2(content.confirmation.bodyKey)}</Typography>
        <CheckBox
          name={content.confirmation.checkboxName}
          label={LanguageConverterV2(content.confirmation.checkboxLabelKey)}
          sx={{
            '& .MuiFormControlLabel-label': {
              color: BLACK[100],
              fontSize: '16px',
              fontFamily: PRIMARY_FONT[500],
            },
          }}
          checked={isChecked}
          onChange={onCheckChange}
        />
      </Box>
      <Box sx={styles.agencyButtonContainer}>
        <Button
          variant="outlined"
          onClick={onClose}
          sx={{ ...styles.backButton, textTransform: 'none' }}
        >
          {LanguageConverterV2('generic.goBack')}
        </Button>
        <Button
          variant="contained"
          sx={styles.agencyChangeButton}
          onClick={onConfirm}
          disabled={!isChecked}
        >
          {LanguageConverterV2(content.confirmation.confirmLabelKey)}
        </Button>
      </Box>
    </DialogContent>
  </Dialog>
);

UserAccountActivationToggleConfirmationModal.propTypes = {
  content: PropTypes.shape({
    confirmation: PropTypes.shape({
      headerKey: PropTypes.string.isRequired,
      bodyKey: PropTypes.string.isRequired,
      checkboxLabelKey: PropTypes.string.isRequired,
      checkboxName: PropTypes.string.isRequired,
      confirmLabelKey: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  isDialogOpen: PropTypes.bool.isRequired,
  isChecked: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCheckChange: PropTypes.func.isRequired,
};

export default UserAccountActivationToggleConfirmationModal;
